import { Box, Chip, Divider, Drawer, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import RunStepList from "./RunStepList";
import type { WorkflowRun } from "./workflow.types";

interface RunSummaryPanelProps {
  open: boolean;
  run: WorkflowRun | null;
  onClose: () => void;
}

const RUN_STATUS_CHIP: Record<string, { label: string; color: "success" | "error" | "default" | "info" | "warning" }> = {
  running: { label: "Running", color: "info" },
  waiting_input: { label: "Needs input", color: "warning" },
  completed: { label: "Completed", color: "success" },
  failed: { label: "Failed", color: "error" },
  stopped: { label: "Stopped", color: "default" },
};

export default function RunSummaryPanel({ open, run, onClose }: RunSummaryPanelProps) {
  const statusMeta = run ? RUN_STATUS_CHIP[run.status] : undefined;

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: 380, p: 2.5 }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <Typography variant="h6" sx={{ flex: 1 }}>
            Run summary
          </Typography>
          <IconButton size="small" onClick={onClose} aria-label="Close">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
        {statusMeta && (
          <Chip size="small" label={statusMeta.label} color={statusMeta.color} sx={{ mb: 2 }} />
        )}
        <Divider sx={{ mb: 2 }} />

        {run ? <RunStepList run={run} /> : (
          <Typography variant="body2" color="text.secondary">
            No steps recorded for this run yet.
          </Typography>
        )}
      </Box>
    </Drawer>
  );
}
